import React, { useEffect } from "react";
import { Routes } from "./routes";
import { GlobalFonts, GlobalStyles } from "@app/components";
import { AuthProvider } from "@app/providers";
// import ReactGA from 'react-ga';
// import RouteChangeTracker from "./providers/analytics"
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
function App() {

  return (
    <>
      <GlobalFonts />
      <GlobalStyles />
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </>
  );
}

export default App;
